import { render } from "./PruebaView.vue?vue&type=template&id=192967a6"
import script from "./PruebaView.vue?vue&type=script&lang=js"
export * from "./PruebaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__